import { render } from "./TvmPreLoader.vue?vue&type=template&id=74155136&scoped=true"
import script from "./TvmPreLoader.vue?vue&type=script&lang=js"
export * from "./TvmPreLoader.vue?vue&type=script&lang=js"

import "./TvmPreLoader.vue?vue&type=style&index=0&id=74155136&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74155136"]])

export default __exports__